import { Reveal, Kicker } from "./Reveal";
import { ArrowRight, Check } from "lucide-react";

const LOOP = ["Monitor", "Predict", "Recommend", "Explain", "Govern", "Approve or Delegate", "Execute", "Measure"];

const GUARANTEES = [
  "Evaluated against approved policy",
  "Routed according to the customer's autonomy level",
  "Recorded in the Decision Ledger",
  "Executed with control and rollback",
  "Linked to its commercial outcome",
];

export default function Product() {
  return (
    <section id="product" className="border-b border-white/10 bg-[#0A0A0B]" data-testid="product-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="02" label="The first product" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="product-heading">
            PriceStrike turns pricing intelligence into{" "}
            <span className="text-[#00FF41]">governed commercial action.</span>
          </h2>
          <p className="mt-8 max-w-2xl font-mono text-sm leading-relaxed text-zinc-400">
            PriceStrike is the first implementation of Axiosera's Commercial Decision Infrastructure.
            It provides a controlled journey from pricing analysis to commercial execution:
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap items-center gap-3" data-testid="product-loop">
            {LOOP.map((step, i) => (
              <span key={step} className="flex items-center gap-3">
                <span className="border border-white/10 bg-[#050505] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:border-[#00FF41] hover:text-[#00FF41]">
                  {step}
                </span>
                {i < LOOP.length - 1 && <ArrowRight className="h-4 w-4 text-zinc-700" />}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="mt-20 grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <h3 className="font-display text-2xl font-bold tracking-tight">Every consequential pricing decision is:</h3>
            <div className="mt-8 space-y-0 border border-white/10">
              {GUARANTEES.map((g, i) => (
                <div key={g} className="flex items-center gap-4 border-b border-white/10 px-6 py-5 last:border-b-0" data-testid={`product-guarantee-${i + 1}`}>
                  <Check className="h-4 w-4 shrink-0 text-[#00FF41]" strokeWidth={2.5} />
                  <span className="font-mono text-sm text-zinc-300">{g}</span>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="scanlines flex h-full flex-col justify-center border border-[#00FF41]/30 bg-[#0F0F11] p-10">
              <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">The chain of custody</div>
              <div className="mt-8 space-y-4 font-mono text-sm" data-testid="product-chain">
                <div className="text-white">AI recommends</div>
                <div className="text-[#00FF41]">↓</div>
                <div className="text-white">Axiosera governs</div>
                <div className="text-[#00FF41]">↓</div>
                <div className="text-white">PriceStrike executes</div>
                <div className="text-[#00FF41]">↓</div>
                <div className="text-white">Customer measures the result</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
